import { connect } from "react-redux";
import { SalaViewProps, mapDispatchToSalaProps, mapStateToSalaProps } from "../sala.controller";
import { Sala } from "../sala.model";
import { Select as ViewList } from "../../../components/select";
import { Box, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import { SalaCadastro } from "./sala.cad";
 
export const columnsSala: GridColDef[] = [
    { field: 'descricao', headerName: 'Sala', flex: 1 },
]

function SalaList(props: SalaViewProps) {
    const { salaActions,salaState } = props
    const { error, loadingRows, msg, row, rows, showAlert, showDialogExluir, status,showCadModal,changeList } = salaState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue,setShowCadModal } = salaActions
    console.log("SalaList props ",props)

    useEffect(()=>{
        if(rows.length === 0)
            read()
    },[])

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    const handleAlterar = (row: any) => {
        console.log("chamou handleAlterar")
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        console.log("chamou handleCloseCadastro")
        setShowCadModal(false)
    }

    function Cadastro() {
        return SalaCadastro({
            ...props,
            handleCloseView: handleCloseCadastro
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: showCadModal,
            heigth: "auto",
            width:"sm"
        })
    }

    const List = ()=>{
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Sala Cadastradas"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleAlterar}
                actionsOnkeyEnter={handleAlterar}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"descricao"}
                columns={columnsSala}
                rows={rows}
                loading={loadingRows}
                setRow={handleAlterar}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick:()=>read()
                }}
                ListItemTextPrimary={(row: Sala) => <Typography component={"span"}>{row.descricao}</Typography>}
            />
        )
    }

    return (
        <div className="modulo">
            <Cadastro />
            <List />
        </div>
    )

}

export default connect(mapStateToSalaProps,mapDispatchToSalaProps)(SalaList);
